export default class MagazineImage {
    public publicationId!: string;
    public page!: number;
    public image!: HTMLImageElement;

    constructor(data: Partial<MagazineImage>) {
        Object.assign(this, data);
    }
}
